// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"109":"31d6cfe0","849":"8c2be281"}[chunkId] + ".chunk.css";
};